export const MUNICIPALITYMANAGEMENT = {
  MODULE: { MAIN: 'module.userProfile.', GENERAL_INFO: 'generalInformation.' },
};
